import { useDeleteRecipientGroup as useDeleteRecipientGroupApi } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'REPORTS.RECIPIENT_GROUPS';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_RECIPIENT_GROUP';

type UseDeleteRecipientGroupReturnType = {
  handleDeleteRecipientGroup: (groupId: string) => void;
};

// Groups and mailings refetch via the generated mutation (see orval.config.ts).
export const useDeleteRecipientGroup =
  (): UseDeleteRecipientGroupReturnType => {
    const { t } = useTranslation();
    const { showSuccess, showError } = useNotification();
    const { mutate: mutateDelete } = useDeleteRecipientGroupApi<AxiosError>();

    const onSuccess = (): void => {
      showSuccess({
        title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
      });
    };

    const onError = (error: AxiosError): void => {
      showError({
        title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
        error,
      });
    };

    const handleDeleteRecipientGroup = (groupId: string): void => {
      modals.openConfirmModal({
        title: t(`${TRANS_PATH}.DELETE_CONFIRMATION_TITLE`),
        labels: {
          confirm: t(`${TRANS_PATH}.DELETE_CONFIRM_BUTTON`),
          cancel: t('CANCEL_BUTTON'),
        },
        confirmProps: {
          color: 'red',
        },
        onConfirm: () => mutateDelete({ groupId }, { onSuccess, onError }),
      });
    };

    return { handleDeleteRecipientGroup };
  };
